<template>
    <main class="chat-room-page">
        <section class="chat-room-shell">
            <header class="chat-room-header">
                <div>
                    <p>Community Room</p>
                    <h1>Bot 交流室</h1>
                </div>
                <span class="room-status">实时在线</span>
            </header>

            <ChatRoomShow :messagelist="messagelist" />
            <ChatRoomTool @post_a_file="post_a_file" />
            <ChatRoomInput @post_a_post="post_a_post" />
        </section>
    </main>
</template>

<script>
import ChatRoomShow from '@/components/ChatRoomShow.vue';
import ChatRoomInput from '@/components/ChatRoomInput.vue';
import ChatRoomTool from '@/components/ChatRoomTool.vue';
import { onUnmounted, reactive } from 'vue';
import { useStore } from 'vuex';
import { wsUrl } from '@/config/backend';

export default {
    name: 'ChatRoomOne',
    components: {
        ChatRoomShow,
        ChatRoomInput,
        ChatRoomTool,
    },
    setup() {
        const store = useStore();
        const messagelist = reactive([]);
        const socket = new WebSocket(wsUrl("/chatroomone/" + store.state.user.username));

        socket.onopen = function () {
            console.log("聊天室连接已打开");
        };

        socket.onmessage = function (msg) {
            const data = JSON.parse(msg.data);
            if (data.error_message === "accept_message" || data.error_message === "send_message") {
                messagelist.push(data);
            }
        };

        const sendSocketMessage = (post) => {
            if (socket.readyState === WebSocket.OPEN) {
                socket.send(post);
            }
        };

        const post_a_post = (post) => {
            sendSocketMessage(post);
        };

        const post_a_file = (post) => {
            sendSocketMessage(post);
        };

        onUnmounted(() => {
            socket.close();
        });

        return {
            post_a_post,
            messagelist,
            post_a_file,
        };
    }
}
</script>

<style scoped>
.chat-room-page {
    min-height: calc(100vh - 86px);
    padding: 24px 16px 32px;
}

.chat-room-shell {
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto auto;
    width: min(960px, 100%);
    margin: 0 auto;
    overflow: hidden;
    background: color-mix(in srgb, var(--app-surface) 94%, transparent);
    border: 1px solid var(--app-border);
    border-radius: 18px;
    box-shadow: var(--app-shadow);
    backdrop-filter: blur(18px);
}

.chat-room-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 20px 24px;
    background: var(--app-surface-muted);
    border-bottom: 1px solid var(--app-border);
}

.chat-room-header p {
    margin: 0 0 4px;
    color: var(--app-muted);
    font-size: 0.78rem;
    font-weight: 800;
}

.chat-room-header h1 {
    margin: 0;
    color: var(--app-text);
    font-size: 1.55rem;
    font-weight: 900;
}

.room-status {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    color: var(--app-text);
    font-weight: 800;
    background: var(--app-surface-strong);
    border: 1px solid var(--app-border);
    border-radius: 999px;
}

.room-status::before {
    content: "";
    width: 9px;
    height: 9px;
    background: #22c55e;
    border-radius: 50%;
    box-shadow: 0 0 12px rgba(34, 197, 94, 0.6);
}

@media (max-width: 768px) {
    .chat-room-page {
        padding: 12px;
    }

    .chat-room-shell {
        border-radius: 14px;
    }

    .chat-room-header {
        padding: 16px 14px;
    }
}
</style>
